<div class="ui-view-header">
    <header>
        <div class="row">
            <div class="col-6 col-offset-0">
                <div class="logo-large"></div>
            </div>
            <div class="col-6 col-offset-6"></div>
        </div>
    </header>
</div>

<div class="container">
    <div class="row">
        <h1 [innerHTML]="'auth.general.logging_in' | translate"></h1>

        <loader [show]="true"></loader>
        <p [innerHTML]="'auth.general.authenticating' | translate"></p>
    </div>
</div>
